import { createApiQueryHook, IApiQueryFunction, IPaginateable, mapPagination } from "../../utils/api";
import { OneOrManyFilter } from "../../utils/filters";
import { serialize } from "../../utils/url";
import { IPageList, PageStatus } from "../types";

export interface IPageListQueryParameters extends IPaginateable {
    filters?: {
        status?: OneOrManyFilter<PageStatus>;
    };
}
export type IPageListQueryResults = IPageList;

const mapFilters = (filters: IPageListQueryParameters["filters"]) => {
    const { status } = filters ?? {};
    return {
        status,
    };
};

export const pageListQuery: IApiQueryFunction<IPageListQueryParameters> = ({ filters, pagination }) => ({
    method: "GET",
    url: `/pages${serialize(
        {
            ...mapPagination(pagination),
            ...mapFilters(filters),
        },
        true,
    )}`,
});

export const usePageListQuery = createApiQueryHook<IPageListQueryParameters, IPageListQueryResults>(pageListQuery);
